var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.useReadOnly
    ? _c("el-input", {
        ref: "cargoInput",
        attrs: {
          value: _vm.value,
          maxlength: _vm.maxlength,
          type: _vm.type,
          rows: _vm.rows,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder || undefined,
          "filter-chars": _vm.filterChars
        },
        on: {
          blur: function($event) {
            return _vm.$emit("blur", $event)
          },
          focus: function($event) {
            return _vm.$emit("focus", $event)
          },
          input: _vm.onInput
        }
      })
    : _c("el-input", {
        ref: "cargoInput",
        class: _vm.disabled ? "is-disabled" : "",
        attrs: {
          value: _vm.value,
          maxlength: _vm.maxlength,
          type: _vm.type,
          rows: _vm.rows,
          readonly: _vm.disabled,
          placeholder: _vm.placeholder || undefined,
          "filter-chars": _vm.filterChars
        },
        on: {
          blur: function($event) {
            return _vm.$emit("blur", $event)
          },
          focus: function($event) {
            return _vm.$emit("focus", $event)
          },
          input: _vm.onInput
        }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }